__turbopack_context__.v({
  "category": "MobileMenu-module-scss-module__5qjK8G__category",
  "category-container": "MobileMenu-module-scss-module__5qjK8G__category-container",
  "category-image": "MobileMenu-module-scss-module__5qjK8G__category-image",
  "category-link": "MobileMenu-module-scss-module__5qjK8G__category-link",
  "category-link-content": "MobileMenu-module-scss-module__5qjK8G__category-link-content",
  "close-button": "MobileMenu-module-scss-module__5qjK8G__close-button",
  "container": "MobileMenu-module-scss-module__5qjK8G__container",
  "menu-link": "MobileMenu-module-scss-module__5qjK8G__menu-link",
  "menu-section": "MobileMenu-module-scss-module__5qjK8G__menu-section",
  "mobile-menu": "MobileMenu-module-scss-module__5qjK8G__mobile-menu",
  "section-heading": "MobileMenu-module-scss-module__5qjK8G__section-heading",
  "section-text": "MobileMenu-module-scss-module__5qjK8G__section-text",
  "text": "MobileMenu-module-scss-module__5qjK8G__text",
  "trigger-button": "MobileMenu-module-scss-module__5qjK8G__trigger-button",
});
